module.exports = __webpack_public_path__ + "img/allsight-logo2-light.c859ac59.svg";